// extracted by mini-css-extract-plugin
module.exports = {"player-info-socials":"info-and-socials-section_player-info-socials__d_9O_"};